import React from 'react';
import { Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

function Blocks() {

  return (
    <div className="justify-center w-1/5">

      {/* Category Grid */}
      <div className="flex flex-col gap-4">
        {/* Screening Card */}
        <div className="h-fit items-center bg-center bg-no-repeat bg-cover text-white flex flex-col justify-center relative text-center w-full rounded-lg shadow-md hover:-translate-y-1 transition-transform" style={{ backgroundImage: "url('https://cdn.builder.io/api/v1/image/assets/TEMP/0e100bad3deff9cd6e3a16f409bb97428418746f95c4461fee221871284b0bd7?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214')" }}>
          <div className="-mt-[130px]">
            <Text className="text-white font-medium">Screening</Text>
            <div className="mt-1">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/20abfd53-491d-4609-8a1f-91545b63c3f3?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214"
                alt=""
                className="w-5 h-5"
              />
            </div>
          </div>
        </div>

        {/* Personality Card */}
        <div className="h-fit items-center bg-center bg-no-repeat bg-cover text-white flex flex-col justify-center relative text-center w-full rounded-lg shadow-md hover:-translate-y-1 transition-transform" style={{ backgroundImage: "url('https://cdn.builder.io/api/v1/image/assets/TEMP/0c2962dab727973401b0d8ace4135fc9e9990c9ef5a5844e117a19d4999ac5c2?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214')" }}>
          <div className="-mt-[130px]">
            <Text className="text-white font-medium">Personality</Text>
            <div className="mt-1">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/58ea4122-1eb5-49db-ab4a-bb4765d1c7e9?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214"
                alt=""
                className="w-5 h-5"
              />
            </div>
          </div>
        </div>

        {/* Behavior Card */}
        <div className="h-fit items-center bg-center bg-no-repeat bg-cover text-white flex flex-col justify-center relative text-center w-full rounded-lg shadow-md hover:-translate-y-1 transition-transform" style={{ backgroundImage: "url('https://cdn.builder.io/api/v1/image/assets/TEMP/58aa5655e283cecc685c6e70e9b19c3a83a01b991e89276a604d58043d5bb793?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214')" }}>
          <div className="-mt-[130px]">
            <Text className="text-white font-medium">Behavior</Text>
            <div className="mt-1">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/1b8c25f7-4fdb-4d0b-8165-2ef09f6cc935?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214"
                alt=""
                className="w-5 h-5"
              />
            </div>
          </div>
        </div>

        {/* Competitive Card */}
        <div className="h-fit items-center bg-center bg-no-repeat bg-cover text-white flex flex-col justify-center relative text-center w-full rounded-lg shadow-md hover:-translate-y-1 transition-transform" style={{ backgroundImage: "url('https://cdn.builder.io/api/v1/image/assets/TEMP/aee2922f9a0413b4c88a1d354fdb9d3c6d02c2a731c9d6771a2da957bfaa5c20?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214')" }}>
          <div className="-mt-[130px]">
            <Text className="text-white font-medium">Coding</Text>
            <div className="mt-1">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/df9678c6-bae7-40e0-a62e-6ff69e76fb65?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214"
                alt=""
                className="w-5 h-5"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blocks;